export default __webpack_public_path__ + "static/media/list_style_square.352856ee.svg";